var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'hero',
    _vm.type,
    ( _obj = {}, _obj[("is-textured-" + _vm.textureBrightness)] = _vm.isTextured, _obj )
  ]},[_c('div',{staticClass:"hero-body has-text-centered-mobile"},[_c('div',{staticClass:"container"},[(_vm.hasSlot('right'))?[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',[_vm._t("default")],2)]),_c('div',{staticClass:"level-right"},[_vm._t("right")],2)])]:[_vm._t("default")]],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }